module.exports = __webpack_public_path__ + "static/img/15.72b874a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/15.png
// module id = T94W
// module chunks = 0